
import { ref, toRaw, computed } from 'vue'
import { useStore } from 'vuex'
import { setNoEmptyForm, setStartDateTime, setEndDateTime } from '@/util/common'
export default (platformOrderStatus: { value: any }) => {
  const orderForm: any = ref({})
  const store = useStore()
  const customerShopId = store.getters.curShop
  const filterData = computed(() => {
    return {
      ...setNoEmptyForm({
        ...toRaw(orderForm.value),
        createStartTime: setStartDateTime(orderForm.value.createStartTime),
        createEndTime: setEndDateTime(orderForm.value.createEndTime),
        deliverTimeStart: setStartDateTime(orderForm.value.deliverTimeStart),
        deliverTimeEnd: setEndDateTime(orderForm.value.deliverTimeEnd)
      }),
      customerShopId,
      platformOrderStatus: platformOrderStatus.value
    }
  })
  return {
    orderForm,
    filterData
  }
}
